<template>
  <div class="container">
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="close">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="black"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>

    <v-dialog v-model="dialog" max-width="350">
      <v-card>
        <v-card-title class="headline primary">
          Upload your csv file
        </v-card-title>
        <v-card-text>
          <label>
            <input
              type="file"
              id="file"
              ref="file"
              @change="handleFileUpload()"
            />
          </label>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="green darken-1" flat="flat" @click="close">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            v-on:click.prevent="uploadFile()"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from "axios";
  import { ROOT_URL } from "@/api/connectingUrls";
  import router from "@/router";
  export default {
    data() {
      return {
        error: 0,
        errorMsg: "",
        dialog: true,
        file: null,
        snackbar: false,
        y: "top",
        x: "right",
        timeout: 3000,
      };
    },
    methods: {
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      close() {
        this.dialog = false;
        this.file = null;
        this.$emit("change", 0);
      },
      async uploadFile() {
        if (this.file != null && this.file != undefined) {
          let formData = new FormData();
          formData.append("csvFile", this.file);
          try {
            const token = window.localStorage.getItem("datadash_token");
            if (token != null) {
              return axios
                .post(`${ROOT_URL}/${"bkash-cashout-file"}`, formData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((response) => {
                  // console.log(response);
                  if (response.data.error == 0) {
                    this.error = response.data.error;
                    this.errorMsg = response.data.errorMsg;
                    this.snackbar = true;
                    this.dialog = false;
                    setTimeout(() => {}, 400);
                  } else {
                    this.error = response.data.error;
                    this.errorMsg = response.data.errorMsg;
                  }
                });
            }
          } catch (error) {
            // console.log(error);
          }
        } else {
          alert("Please choose a valid CSV file!");
        }
      },
    },
  };
</script>

<style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>
